import { render } from "./IconExit.vue?vue&type=template&id=549bfd0e&scoped=true&ts=true"
import script from "./IconExit.vue?vue&type=script&lang=ts"
export * from "./IconExit.vue?vue&type=script&lang=ts"

import "./IconExit.vue?vue&type=style&index=0&id=549bfd0e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-549bfd0e"]])

export default __exports__